import React, { useMemo } from 'react';
import getIn from '../../connectedForm/utils/getIn';
import { Popover, PopoverSurface, PopoverTrigger } from '@fluentui/react-components';
import { BookInformationRegular } from '@fluentui/react-icons';
import { BasicHeader } from '../../../actions/BasicHeader';
import { STATUS_CELL_BASIC_HEADER_STYLES } from '../../CellFormatters/util';

const PopoverFormatter = ({ value, ...props }) => {
  const Formatter = getIn(props, 'dependentValues.options.formatter');
  const ExpandedContentFormatter = getIn(props, 'dependentValues.options.expandedContentFormatter');
  const displayKey = getIn(props, 'dependentValues.options.displayKey');

  const expandedContentTitle = getIn(props, 'dependentValues.options.expandedContentTitle');
  const expandedContentSubtitle = getIn(props, 'dependentValues.options.expandedContentSubtitle');

  const cellDisplayValue = useMemo(() => {
    if (displayKey) {
      return value.length && value.length > 0 ? value[0][displayKey] : value[displayKey];
    } else {
      return value;
    }
  }, [displayKey, value]);

  return (
    <Popover openOnHover={true} positioning={'after-bottom'} mouseLeaveDelay={0}>
      <PopoverTrigger>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Formatter {...props} value={cellDisplayValue} />
          <BookInformationRegular fontSize={18} />
        </div>
      </PopoverTrigger>
      <PopoverSurface style={{ padding: 0, opacity: 0.85, maxWidth: '900px' }}>
        <BasicHeader secondaryTitle={expandedContentSubtitle} styles={STATUS_CELL_BASIC_HEADER_STYLES}>
          {expandedContentTitle}
        </BasicHeader>
        <div style={{ padding: '1em', paddingLeft: '2em', paddingRight: '2em', minWidth: '650px' }}>
          <ExpandedContentFormatter {...props} value={value} />
        </div>
      </PopoverSurface>
    </Popover>
  );
};

export default PopoverFormatter;
